// src/pages/Cancel.js
import React, { useEffect, useState } from 'react';
import { db } from '../services/firebase';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';

export default function Cancel() {
  const [state, setState] = useState<'loading'|'ok'|'err'>('loading');

  useEffect(() => {
    const run = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('ref') || '';
        const id = params.get('id') || '';
        if (!token || !id) throw new Error('Bad link');

        const ref = doc(db, 'registrations', id);
        await updateDoc(ref, {
          status: 'cancelled',
          cancelledAt: serverTimestamp(),
          // important: renvoyer le token à l’identique (vérifié par les règles)
          cancelToken: token
        });

        setState('ok');
      } catch (e) {
        console.error('Cancel error', e);
        setState('err');
      }
    };
    run();
  }, []);

  if (state === 'loading') return <p>Annulation en cours…</p>;
  if (state === 'ok') return <p>✔️ Votre inscription a été annulée. Merci de nous avoir prévenus.</p>;
  return <p>❌ Lien invalide ou déjà annulé. Contactez-nous si besoin.</p>;
}
